import React, { useState } from 'react';
import { Theme } from '../../Enums/Theme.enum';
import LinkButton from '../Button/LinkButton';
import { useModalContext } from '../../Modules/Modal/Services/ModalContext';
import ModalCloseConfirmation from '../../Modules/Modal/Components/ModalCloseConfirmation';
import { TreatmentFormModalContextKeys } from './TreatmentFormModalContextKeys';

interface Props {
	onClose?: () => void;
}

const TreatmentCloseButton: React.FC<Props> = ({ onClose }) => {
	const { checkIfModalCanBeClosedByKeys } = useModalContext();
	const [isCloseConfirmationOpen, setIsCloseConfirmationOpen] = useState(false);

	const handleOnClose = () => {
		if (
			checkIfModalCanBeClosedByKeys(
				Object.values(TreatmentFormModalContextKeys),
			)
		) {
			onClose?.();
		} else {
			setIsCloseConfirmationOpen(true);
		}
	};

	return (
		<>
			<LinkButton
				title={'base.shared.close'}
				theme={Theme.RED}
				onClick={handleOnClose}
			/>
			{isCloseConfirmationOpen && (
				<ModalCloseConfirmation
					isOpen={isCloseConfirmationOpen}
					onReject={() => setIsCloseConfirmationOpen(false)}
					onConfirm={() => onClose?.()}
				/>
			)}
		</>
	);
};

export default TreatmentCloseButton;
